import React from 'react';
import Body from './Body';
import './styles/Main.css';
import Navbar from './Navbar';


function Main() {
    return (
        <div className="main">
            <Navbar />
            <Body />
        </div>
    )
}
export default Main
